//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { XIcon } from '@vue-hero-icons/outline'
import DTIconButton from '../DTIconButton/DTIconButton'
import { classArray } from '../../utils/class'
import { DTModalHeaderInjector } from '../../keys'

export default {
  components: { DTIconButton, XIcon },
  inject: {
    modal: {
      from: DTModalHeaderInjector,
      default: null,
    },
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    titleClass: {
      type: [String, Array, Object],
      default: null,
    },
    useClose: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    titleClasses() {
      return classArray(this.titleClass).concat([
        'tw-font-semibold tw-text-gray-800 tw-mb-0 tw-text-base',
      ])
    },
  },
  beforeMount() {
    if (!this.modal) {
      throw new Error('Trying to use DTModalHeader outside DTModal')
    }
  },
}
